<div class="card card-stats">
  <div class="card-body">
    <div *ngIf="members.length > 0" class="">
      <h4 class="card-title text-uppercase mb-0 text-mtek">
        Group policy members: {{ members.length }}
      </h4>
      <br />
      <div
        class="d-flex justify-content-between mb-10 ben-card ben-container"
        *ngFor="let member of members; let i = index"
      >
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Name
          </small>
          <span>
            {{ member?.name }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Email
          </small>
          <span>
            {{ member?.email }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Gender
          </small>
          <span>
            {{ member?.gender }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            DOB
          </small>
          <span>
            {{ member?.dateOfBirth | CustomDatePipe }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            ID Number
          </small>
          <span>
            {{ member?.idNo }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Phone Number
          </small>
          <span>
            {{ member?.phone }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Policy Number
          </small>
          <span>
            {{ member?.policyNumber }}
          </span>
        </div>
        <div>
          <small class="d-block text-dark text-uppercase bold-text">
            Membership Number
          </small>
          <span>
            {{ member?.membershipNo }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
